import * as PropTypes from 'prop-types';

import {SchemaTag, TAG_FIELDS} from 'folder-items/FileConstants';

export const HOISTED_TAG = PropTypes.shape({
  ...TAG_FIELDS,
  tagSchemaGraphId: PropTypes.number.isRequired,
});

export interface HoistedTag extends SchemaTag {
  tagSchemaGraphId: number;
}
